<template>
  <div class="ts-number-control">
    <v-btn icon small @click="add(1)"><v-icon>mdi-plus</v-icon></v-btn>
    <v-btn icon small @click="add(-1)"><v-icon>mdi-minus</v-icon></v-btn>
  </div>
</template>

<style lang="scss">
  .ts-number-control{
    display:inline-flex;
  }
</style>

<script>
export default {
  name: "TsNumberControl",
  props:{
    value: [String,Number],
    min: Number,
    max: Number
  },
  methods: {
    add(delta){
      let newValue = this.value- -delta
      if(!isNaN(this.min)) newValue = Math.max(this.min,newValue)
      if(!isNaN(this.max)) newValue = Math.min(this.max,newValue)
      this.$emit('input', newValue)
    }
  }
}
</script>
